import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import {
    fetchExtensionLicenseDescriptions,
    fetchPbxLicense,
} from 'flow/actions/license-actions';
import SettingsListItem from 'flow/components/custom-components/SettingsListItem';
import Page from 'flow/components/Setting/Page';
import SettingSection from 'flow/components/Setting/SettingSection';
import Icon from 'flow/components/ui-components/Icon';
import useAppContext from 'flow/hooks/useAppContext';
import {
    selectExtensionLicenseDescription,
    selectPbxLicenseDescription,
} from 'flow/selectors/license-selectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';

const SettingsAccountLicense = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();

    const companyLicenseDescription = useAppSelector(
        selectPbxLicenseDescription,
    );
    const userLicenseDescription = useAppSelector((state) =>
        selectExtensionLicenseDescription(state, extensionKey),
    );

    useEffect(() => {
        dispatch(fetchPbxLicense());
        dispatch(fetchExtensionLicenseDescriptions());
    }, []);

    return (
        <Page
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.account'], { extensionKey }),
                )
            }
            header={'Settings.Account.License'}
        >
            <SettingSection>
                {i18next.t('Settings.Account.License.Company')}
            </SettingSection>

            <SettingsListItem
                className="hover:bg-transparent"
                description={companyLicenseDescription}
            >
                <Icon iconKey="business" />
                {i18next.t('Settings.Account.License.Company')}
            </SettingsListItem>

            <SettingSection className="mt-9">
                {i18next.t('Settings.Account.License.User')}
            </SettingSection>

            <SettingsListItem
                className="hover:bg-transparent"
                description={userLicenseDescription}
            >
                <Icon iconKey="accountCircle" />
                {i18next.t('Settings.Account.License.User')}
            </SettingsListItem>
        </Page>
    );
};

export default SettingsAccountLicense;
